<template lang="html">
  <div v-show="false">
    <!-- These are hidden, but necessary for shortkeys -->
    <p v-for="(item, idx) in items" :key="'shortkey' + idx">
      <button
        v-shortkey="item.shortkey"
        @shortkey="$emit(item.emitter)"
        @click="$emit(item.emitter)"
      >
        {{ item.emitter }}
      </button>
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        { shortkey: ["arrowleft"], emitter: "previousImage" },
        { shortkey: ["arrowright"], emitter: "nextImage" },
        { shortkey: ["j"], emitter: "scrubRewind" },
        { shortkey: ["k"], emitter: "playToggle" },
        { shortkey: ["l"], emitter: "scrubForward" },
        { shortkey: ["meta", "="], emitter: "zoomIn" },
        { shortkey: ["meta", "-"], emitter: "zoomOut" },
        { shortkey: ["ctrl", "="], emitter: "timelineThumbLarger" },
        { shortkey: ["ctrl", "-"], emitter: "timelineThumbSmaller" },
        { shortkey: ["ctrl", "a"], emitter: "focusToggle" },
        //{ shortkey: ["esc"], emitter: "escape" },
        { shortkey: ["meta", "shift", "del"], emitter: "clearSlideArray" },
        { shortkey: ["space"], emitter: "playToggle" },
        { shortkey: ["meta", "z"], emitter: "undoEdit" },
        { shortkey: ["meta", "shift", "z"], emitter: "redoEdit" },
        { shortkey: ["meta", "enter"], emitter: "viewActiveShow" },
        { shortkey: ["ctrl", "shift", "d"], emitter: "clearLockedSlides" },
        { shortkey: ["meta", "l"], emitter: "switchLayout" },
        { shortkey: ["del"], emitter: "deleteKey" },
        { shortkey: ["backspace"], emitter: "deleteKey" }
      ]
    };
  }
};
</script>

<style lang="css" scoped></style>
